import Translator from '../../classes/Translator/Translator';
import Session from '../../classes/Session/Session';
import { useHistory } from 'react-router-dom';

const ChildProjectsListLogic = () => {
  const { translator } = Translator();
  const history = useHistory();
  const hasSession = new Session({}).hasSession();

  const goToDmrv = (e) => {
    e.preventDefault();
    if (hasSession) {
      history.push('/dmrv');
    } else {
      history.push('/login');
    }
  };

  return {
    translator,
    goToDmrv,
  };
};

export default ChildProjectsListLogic;